import baseScmService from 'services/baseScmService';

const superBatchProjectService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    getSuperBatchProject: build.query({
      query: (superBatchProjectId) => ({
        method: 'GET',
        url: `/super-batch-projects/${superBatchProjectId}`,
      }),
      providesTags: (result, error, superBatchProjectId) => {
        return error
          ? []
          : [{ type: 'SuperBatchProject', id: superBatchProjectId }];
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetSuperBatchProjectQuery } = superBatchProjectService;

export default superBatchProjectService;
